import { cn } from '@/utils/tailwind.util';
export const NewBadge = ({
  className
}: {
  className?: string;
}) => {
  return <span className={cn('text-caption-md-semibold text-white size-[18px] rounded-full bg-status-destructive border border-opacity-assistive flex items-center justify-center', className)} data-sentry-component="NewBadge" data-sentry-source-file="NewBadge.tsx">
      N
    </span>;
};